<template>
    <v-layout row wrap fill-height align-center justify-center class="py-5">
        <v-flex xs12 sm8 md7 lg6 xl4>
            <v-card>
                <v-card-text class="pa-4">
                    <h2 class="display-1 mb-4">Děkujeme za vaši objednávku</h2>
                    <p>Objednávka byla zaslána ke zpracování o jejím vyřízení budete informováni e-mailem.</p>
                    <v-btn class="my-0 ml-0" large flat color="primary" @click="backToHp">Zpět na úvodní stranu</v-btn>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import Footer from '@/components/Footer'

    export default {
        components: {
            'footer-nav': Footer
        },
        data() {
            return {}
        },
        methods: {
          backToHp() {
            this.$store.commit('setActualStep', 1);
            this.$router.push('step-1');
          },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Step6.vue